import styled from "styled-components";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export const StyledOpenShift = styled.div`
  width: 90%;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 80%;
  box-shadow: 5px 15px 15px -10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 5px;
  padding: ${({ padding }) => padding || "5px"};
  line-height: ${({ lineHeight }) => lineHeight};
  overflow: ${({ isMultipleShifts }) =>
    isMultipleShifts ? "visible" : "hidden"};
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: ${({ margin }) => margin || "0 1px"};
  cursor: pointer;
  position: absolute;

  color: ${({ color }) => color};
  background-color: ${({ backgroundColor }) => backgroundColor};
  background: ${({ background }) => background};
  border: ${({ border }) => border};

  top: ${({ isMultipleShifts }) => (isMultipleShifts ? "7%" : "10%")};
  left: ${({ isMultipleShifts }) => (isMultipleShifts ? "2%" : "5%")};

  &:after {
    display: ${({ isMultipleShifts }) => (isMultipleShifts ? "block" : "none")};
    position: absolute;
    z-index: -1;
    top: 5px;
    left: 5px;
    content: "";
    width: 100%;
    height: 100%;

    color: ${({ color }) => color};
    background-color: ${({ backgroundColor }) => backgroundColor};
    background: ${({ background }) => background};
    border: ${({ border }) => border};

    border-radius: 5px;
    opacity: 0.8;
  }
`;

export const StyledPredicted = styled.div`
  display: inline-block;
  padding: 0 10px;
  font-size: 150%;
  line-height: 14px;
  &:after {
    content: "📶";
  }
`;

export const Div = styled.div`
  display: flex;
  width: ${({ width }) => width};
  justify-content: center;
  align-items: center;
  line-height: ${({ lineHeight }) => lineHeight};

  font-size: ${({ fontSize }) => fontSize || STYLE_CONSTS.FONT};
  font-weight: ${({ fontWeight }) => fontWeight || STYLE_CONSTS.FONT_WEIGHT};
  text-transform: ${({ textTransform }) => textTransform};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  text-overflow: ellipsis;
  white-space: ${({ wrap }) => wrap || "nowrap"};
`;
